export enum ROLES {
  ADMIN = 'Admin',
  PRIMARY_INSTRUCTOR = 'Primary Instructor',
  ADDITIONAL_INSTRUCTOR = 'Additional Instructor',
  STUDENT = 'Student',
  ACADEMIC_UNIT_OWNER = 'Academic Unit Owner',
  ACCOUNT_OWNER = 'Account Owner',
  SYSTEM_MANAGER = 'System Manager',
  OWNER = 'Owner',
  VIEWER = 'Viewer',
  EDITOR = 'Editor',
  TEACHING_ASSISTANT = 'Teaching Assistant',
  SUPPORT_STAFF = 'Support Staff'
}

export const CURRENT_ROLE_ID_KEY = 'currentRoleId'

export enum ReportRoles {
  AccountOwner = 'Account Owner',
  SystemManager = 'System Manager',
  Owner = 'Owner',
  Viewer = 'Viewer',
  Editor = 'Editor',
  PRIMARY_INSTRUCTOR = 'Primary Instructor',
  ADDITIONAL_INSTRUCTOR = 'Additional Instructor',

}

export const SCOPE_TOGGLE_ALLOWED_ROLES = [
  ReportRoles.Viewer,
  ReportRoles.Editor,
  ReportRoles.Owner,
  ReportRoles.PRIMARY_INSTRUCTOR,
  ReportRoles.ADDITIONAL_INSTRUCTOR
]
